import { MagicInput, message, Modal } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useRef } from 'react'
import Api from '../../../../api'
import DesignConcept from '../../area/DesignConcept'
import DesignDiagram from '../../area/DesignDiagram'
import NoSet from '../../area/NoSet'
import PictureShow from '../../area/PictureShow'
import OperableArea from '../../common/OperableArea'
import { KIND } from '../../constants'
import style from './style.module.less'

const ShowArea = ({ contentStore, caseImageTag }) => {
  const {
    active,
    setActive,
    list,
    setDesignVisible,
    initShowAreaRef
  } = contentStore
  const displayAreaRef = useRef(null)

  useEffect(
    () => {
      initShowAreaRef(displayAreaRef)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [displayAreaRef]
  )

  /**
   * @title 检查文字是否存在敏感词
   */
  const checkWord = async (content, type = 2) => {
    if (!content || !content.trim()) {
      return { code: 0 }
    }
    const { data, success } = await Api.checkWord({ content, type })
    if (success) {
      const length = data?.keywords?.length
      length &&
        message.error(
          `内容中存在敏感 ${data?.keywords.join(',')}，请检查后提交`
        )
    }
  }

  const Comp = item => {
    if (!item) {
      return null
    }
    const { kind } = item
    const area = {
      [KIND.DesignDiagram]: (
        <OperableArea
          quickAction={['edit', 'remove']}
          edit={() => {
            setDesignVisible(true)
          }}
          remove={() => {
            Modal.confirm({
              title: '确定要删除吗？',
              onOk: () => {
                const index = list.findIndex(
                  f => f?.kind === KIND['DesignDiagram']
                )
                list.splice(index, 1, undefined)
              }
            })
          }}
          title="设计稿"
          id={KIND['DesignDiagram']}
          active={active}
          onClick={setActive}
          style={{
            padding: !item?.imgs && 0
          }}
        >
          <DesignDiagram images={item?.imgs} />
        </OperableArea>
      ),
      [KIND.DesignConcept]: (
        <OperableArea
          quickAction={['remove']}
          remove={() => {
            Modal.confirm({
              title: '确定要删除吗？',
              onOk: () => {
                const index = list.findIndex(
                  f => f?.kind === KIND['DesignConcept']
                )
                list.splice(index, 1, undefined)
              }
            })
          }}
          title="设计构思"
          id={KIND['DesignConcept']}
          active={active}
          onClick={setActive}
          actionRender={
            <>
              <MagicInput.TextArea
                onBlur={e => {
                  checkWord(e.target.value)
                }}
                countPosition="inner"
                value={item?.text}
                autoSize={{ minRows: 12, maxRows: 12 }}
                bordered={false}
                maxLength={200}
                showCount
                onChange={e => (item.text = e.target.value)}
                placeholder="请输入婚礼设计的灵感构思以及婚礼布置的元素"
              />
            </>
          }
        >
          <DesignConcept text={item?.text} />
        </OperableArea>
      ),
      '3': (
        <div
          style={{
            padding: !item?.imgs?.length ? 0 : '12px 0'
          }}
        >
          <PictureShow
            caseImageTag={caseImageTag}
            kind={KIND['StageCeremony']}
            imgs={item?.imgs}
            title="舞台仪式区"
          />
        </div>
      ),
      '4': (
        <div
          style={{
            padding: !item?.imgs?.length ? 0 : '12px 0'
          }}
        >
          <PictureShow
            caseImageTag={caseImageTag}
            kind={KIND['WelcomeSign']}
            imgs={item?.imgs}
            title="迎宾签到区"
          />
        </div>
      ),
      '5': (
        <div
          style={{
            padding: !item?.imgs?.length ? 0 : '12px 0'
          }}
        >
          <PictureShow
            caseImageTag={caseImageTag}
            kind={KIND['WeddingDetail']}
            imgs={item?.imgs}
            title="婚礼细节"
          />
        </div>
      ),
      '6': (
        <OperableArea onClick={setActive}>
          <NoSet imgs={item?.imgs} />
        </OperableArea>
      )
    }
    return area[kind] ?? null
  }

  return (
    <div className={style.displayArea} ref={displayAreaRef} id="displayArea">
      <div className={style.header}>
        <img
          src="https://qnm.hunliji.com/camel-13a7b367-dd6c-4194-b725-6b5931bf209d.png"
          style={{ width: 360, height: 60 }}
        />
      </div>
      <div className={style.content}>{list.map(item => <>{Comp(item)}</>)}</div>
    </div>
  )
}

export default inject('contentStore')(observer(ShowArea))
